import { render, staticRenderFns } from "./AddKeyVault.vue?vue&type=template&id=ba5b616c&scoped=true&"
import script from "./AddKeyVault.vue?vue&type=script&lang=js&"
export * from "./AddKeyVault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5b616c",
  null
  
)

export default component.exports